module.exports = __webpack_public_path__ + "assets/img/haveObtained_bg.0c8c7b0f.png";